export default theme => ({
  container: {
    backgroundColor: theme.palette.yellow.main,
    color: theme.palette.yellow.contrastText,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(4),
    },
  },
  title: {
    maxWidth: '50%',
  },
  titleSep: {
    width: 70,
    height: 4,
    backgroundColor: theme.palette.yellow.contrastText,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
  },
  desc: {
    fontWeight: 700,
    marginBottom: theme.spacing(6),
  },
  buttonContainer: {
    color: theme.palette.common.white,
  },
  formeRow: {
    position: 'relative',
    width: '100%',
    textAlign: 'center',
  },
  formeContainer: {
    display: 'inline-block',
    width: 550,
    height: 360,
    marginTop: -120,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      width: '100%',
      height: 450,
    },
  },
  graphDesk: {
    display: 'inline-block',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  graphResp: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'inline-block',
    },
  },
  hexaContainer: {
    position: 'absolute',
    zIndex: 3,
    overflow: 'hidden',
    pointerEvents: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  hexaContainer1: {
    left: 0,
    bottom: -45,
  },
  hexaContainer2: {
    right: 0,
    top: '50%',
  },
  hexa1: {
    marginLeft: -60,
  },
  hexa2: {
    marginRight: -35,
  },
});
